import Vue from 'vue'
import App from './App.vue'

//1 eui组件
import ElementUI from 'element-ui';
// 2 eui 样式
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css';
// import axios from "axios";
import utils from "./utils/utils";
import VueRouter from "vue-router";
import router from "./router/index";
import store from './store/index'
import axios from 'axios'


Vue.prototype.$http = axios;
Vue.prototype.utils = utils;
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
